import { render } from "./TargetsZones.vue?vue&type=template&id=3c16e8e9"
import script from "./TargetsZones.vue?vue&type=script&lang=js"
export * from "./TargetsZones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__